import { render } from "./PanelTipsterDevoluciones.vue?vue&type=template&id=1d72728b&scoped=true"
import script from "./PanelTipsterDevoluciones.vue?vue&type=script&lang=js"
export * from "./PanelTipsterDevoluciones.vue?vue&type=script&lang=js"

import "./PanelTipsterDevoluciones.vue?vue&type=style&index=0&id=1d72728b&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d72728b"]])

export default __exports__